import { render } from "./HumanRecord.vue?vue&type=template&id=3f5f1370&scoped=true"
import script from "./HumanRecord.vue?vue&type=script&lang=js"
export * from "./HumanRecord.vue?vue&type=script&lang=js"

import "./HumanRecord.vue?vue&type=style&index=0&id=3f5f1370&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5f1370"]])

export default __exports__